/**
 * Repository - InMemoryCashRegisterRepository
 *
 * Implémentation du repository de caisse en mémoire
 */

import { ICashRegisterRepository } from '../../application/ports/output/ICashRegisterRepository';
import { CashRegister } from '../../domain/entities/CashRegister';

const STORAGE_KEY = 'biotransac_cash_register';

export class InMemoryCashRegisterRepository implements ICashRegisterRepository {
  private cashRegister: CashRegister;

  constructor(cashierId: string = 'CAISSIER_PRINCIPAL') {
    // Charger depuis localStorage ou créer une nouvelle caisse
    const stored = this.loadFromStorage();
    this.cashRegister = stored || CashRegister.create(cashierId);
  }

  /**
   * Récupère la caisse courante
   */
  async get(): Promise<CashRegister> {
    return this.cashRegister;
  }

  /**
   * Sauvegarde l'état de la caisse
   */
  async save(cashRegister: CashRegister): Promise<void> {
    this.cashRegister = cashRegister;
    this.persistToStorage(cashRegister);
  }

  /**
   * Réinitialise la caisse (pour les clôtures)
   */
  async reset(cashierId: string): Promise<void> {
    this.cashRegister = CashRegister.create(cashierId);
    this.persistToStorage(this.cashRegister);
  }

  /**
   * Charge la caisse depuis localStorage
   */
  private loadFromStorage(): CashRegister | null {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (!stored) {
        return null;
      }
      const json = JSON.parse(stored);
      return CashRegister.fromJSON(json);
    } catch (error) {
      console.error('Erreur lors du chargement de la caisse:', error);
      return null;
    }
  }

  /**
   * Persiste la caisse dans localStorage
   */
  private persistToStorage(cashRegister: CashRegister): void {
    try {
      const json = cashRegister.toJSON();
      localStorage.setItem(STORAGE_KEY, JSON.stringify(json));
    } catch (error) {
      console.error('Erreur lors de la sauvegarde de la caisse:', error);
    }
  }
}
